<template>
<div id="footer">
  <div id="foot_nav">
    <div class="nav_div">
      <div>
        <ul>
          <li><a href="/../index.html" class="foot_ttl">HOME</a></li>
          <li><a href="/../company/information.html" class="foot_ttl">会社案内</a></li>
          <li><a href="/../company/aboutus.html">電動舎のご紹介</a></li>
          <li><a href="/../company/outline.html">会社概要</a></li>
          <li><a href="/../company/nextgen-support.html">次世代育成支援行動計画</a></li>
          <li><a href="/../recruitment/fresh.html">新卒採用</a></li>
          <li><a href="/../recruitment/career.html">キャリア採用</a></li>
        </ul>
      </div>
      <div>
        <ul>
          <li><a href="/../products/category.html" class="foot_ttl">商品紹介</a></li>
          <li><a href="/../catalog/">取扱商品</a></li>
          <li><a href="/../products/category_pdf.html">商品カタログ（PDF）</a></li>
          <li><a href="/../recommend/items_list.html">お勧め商品</a></li>
          <li><a href="/../recommend/items_movie.html">商品動画</a></li>
          <li><a href="/../link.html">リンク</a></li>
          <li><a href="/../products/faq_list.html">困ったときは（Q&amp;A)</a></li>
        </ul>
      </div>
      <div>
        <ul>
          <li><a href="/../products/disclaimers.html">免責事項</a></li>
          <li><a href="/../products/download_pdf.html">ダウンロード</a></li>
          <li><a href="/../pdf/rental-guidevol26_correct.pdf" target="_blank">電動舎カタログ正誤表［Vol.26］</a></li>
          <li><a href="/../pdf/accident-report.pdf" target="_blank">事故報告書PDFダウンロード</a></li>
          <li><a href="/../news/news-list.html">お知らせ一覧</a></li>
          <li><a href="/../company/office.html">営業所紹介</a></li>
          <li><a href="/../privacy.html">プライバシーポリシー</a></li>
        </ul>
      </div>
      <div>
        <ul>
          <li class="foot_ttl">資料</li>
          <li><a href="/../document/general-conditions.html">レンタル約款</a></li>
          <li><a href="/../pdf/article-rental-support201807.pdf" target="_blank">レンタル物件サポート特約制度</a></li>
          <li><a href="/../document/special-contract.html">レンタル保険制度</a></li>
          <li><a href="/../document/law.html">法規</a></li>
          <li><a href="/../document/qualification.html">資格</a></li>
          <li><a href="/../document/unit.html">単位</a></li>
        </ul>
        <!-- <div class="clear"></div>-->
      </div>
        <div>
        <ul>
          <li><a href="/../document/guide.html">ご利用ガイド</a></li>
          <li><a href="/../sitemap.html">サイトマップ</a></li>
        </ul>
        <div class="clear"></div>
      </div>
    </div>
   
        <!--  snsアイコン-->      
      <div class="sns-icon">
        <ul>
          <li><a href="https://instagram.com/dendousya_used_official?igshid=YmMyMTA2M2Y=" title="Instagram 電動舎中古情報" target="_blank"><i class="fab fa-instagram" aria-hidden="true"></i><span class="sr-only">Instagram</span></a> <a href="https://www.youtube.com/channel/UCYScC0ycwXCO--PzbWIaobw/videos" title="YouTube 電動舎チャンネル" target="_blank"><i class="fab fa-youtube" aria-hidden="true"></i><span class="sr-only">YouTube</span></a></li>
        </ul>
<!--<div class="clear"></div>-->
      </div>
    <!--  snsアイコン-->
    <div class="clear"></div>
  </div>
  <!-- #foot_nav -->
  <div id="copyright">All Rights Reserved by DENDOUSYA CORPORATION</div>
</div>
</template>
